import { render } from "./TotalCount.vue?vue&type=template&id=aa3a97b0&ts=true"
import script from "./TotalCount.vue?vue&type=script&lang=ts"
export * from "./TotalCount.vue?vue&type=script&lang=ts"

import "./TotalCount.vue?vue&type=style&index=0&id=aa3a97b0&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__